import { Component, HostListener, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppUtils } from '../../../core/config/app.utils';
import { NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FilesService } from '../../../core/services/files.service';
import { DriverService } from '../../../core/services/driver.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { FleetService } from '../../../core/services/fleet.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SETTINGS } from '../../../core/config/common.settings';
import { SupplierService } from '../../../core/services/supplier.service';
import { IDeactivateComponent } from '../../../core/guards/deactivate.gaurd';

const ADD_EDIT_DRIVER_LICENCE_UPLOAD = 'ADD_EDIT_DRIVER_LICENCE_UPLOAD';
// const ADD_EDIT_DRIVER_PAYMENTS_UPLOAD = 'ADD_EDIT_DRIVER_PAYMENTS_UPLOAD';
const ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD =
  'ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD';

@Component({
  selector: 'app-add-edit-drivers',
  templateUrl: './add-edit-drivers.component.html',
  styleUrls: ['./add-edit-drivers.component.scss'],
})
export class AddEditDriversComponent implements OnInit, IDeactivateComponent {
  breadcrumbs: any[] = [];
  driverId: any;
  driverData: any;
  fleetOptions: any[] = [];
  fleetSearchField: any;
  suppliers: any;
  driverForm: FormGroup | any;
  formErrors: any;
  innerLicenseDetailsErrors: any;
  isOutsourceDriver = false;
  isSrDriver = false;
  // isASupplier = false;
  canDriveOptions = [
    { label: 'Light Vehicles', value: true },
    { label: 'Heavy Vehicles', value: true },
  ];
  licenceAttachments: any[] = [];
  otherAttachments: any[] = [];
  licenceAttachmentUploading = false;
  otherAttachmentUploading = false;

  hasLicenseSubject = new BehaviorSubject(false);

  hasTourLicense = false;
  hasChauffeurGuideLicense = false;
  hasNationalGuideLicense = false;

  isValidSingleVehicleForm = true;
  visibleAddSupplierPopup = false;
  submit = false;
  prevPage: any;
  loading = false;

  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any): string | undefined {
    const confirmationMessage =
      'You have unsaved changes. Do you really want to leave?';
    $event.returnValue = confirmationMessage; // Standard for most browsers
    return confirmationMessage; // For some older browsers
  }

  constructor(
    private fb: FormBuilder,
    private filesService: FilesService,
    private driverService: DriverService,
    private fleetService: FleetService,
    private router: Router,
    private route: ActivatedRoute,
    private messages: NzMessageService,
    private supplierService: SupplierService,
  ) {
    this.formErrors = {
      driverSegment: {},
      supplier: {},
      isRegistered: {},
      contractOrPermanent: {},
      fullName: {},
      mobileNumber: {},
      email: {},
      nicNo: {},
    };
    this.innerLicenseDetailsErrors = {
      licenseDetails: {
        drivingLicenseExpiryDate: {},
      },
    };
  }

  ngOnInit(): void {
    // this.getSystemVehicles();
    this.initDriverForm();
    this.getSuppliers();
    this.driverId = this.route.snapshot.paramMap.get('id');
    this.route.queryParams.subscribe((params) => {
      this.prevPage = params['prev'];
    });

    if (this.route.snapshot.paramMap.get('id')) {
      this.loading = true;
      this.driverService.getOneDriverById(this.driverId).then((res: any) => {
        this.driverData = res;
        this.setBreadcrumbs(res);

        this.driverForm.patchValue(this.driverData);
        this.otherAttachments = res?.attachments;
        this.licenceAttachments = res?.licenseDetails?.attachments;
        this.loading = false;
      });
    } else {
      this.setBreadcrumbs();
    }

    this.filesService.fileUploadingSubject.subscribe((res: any) => {
      if (res.type === ADD_EDIT_DRIVER_LICENCE_UPLOAD) {
        this.licenceAttachmentUploading = res.loading;
      }
      if (res.type === ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD) {
        this.otherAttachmentUploading = res.loading;
      }
    });

    this.supplierService.suppliersOnChange.subscribe((res: any[]) => {
      this.suppliers = res;
    });
  }

  getSuppliers(): void {
    this.supplierService.getAllSuppliers().then((res) => {});
  }

  // getSystemVehicles(): void {
  //   this.fleetService.getFleetsAsOptions({}).then((res) => {
  //     this.fleetOptions = res as any;
  //   });
  // }

  navigateToAddSupplier(): void {
    this.visibleAddSupplierPopup = true;
  }

  setBreadcrumbs(data?: any): void {
    if (data) {
      this.breadcrumbs = [
        {
          title: ' Drivers ',
          icon: 'team',
          route: '/admin/drivers',
        },
        {
          title: `${data?.refNo}`,
          route: `/admin/drivers/${data?._id}`,
        },
        {
          title: ' Edit ',
        },
      ];
    } else {
      this.breadcrumbs = [
        {
          title: ' Drivers ',
          icon: 'team',
          route: '/admin/drivers',
        },
        {
          title: ' Add ',
        },
      ];
    }
  }

  // Language Skills form loop array stuff
  createLanguage(): FormGroup {
    return this.fb.group({
      language: [null],
      level: [null],
    });
  }

  get languageSkills(): FormArray {
    return this.driverForm.get('languageSkills');
  }

  addItems() {
    this.languageSkills.push(this.createLanguage());
  }

  removeItem(event: Event, i: any): void {
    this.languageSkills.removeAt(i);
  }

  initDriverForm(): void {
    this.driverForm = this.fb.group({
      driverSegment: [null, [Validators.required]],
      supplier: [null, []],
      contractOrPermanent: [null, []],
      isRegistered: [null, []],
      fullName: [
        null,
        [
          Validators.compose([
            Validators.required,
            Validators.pattern(SETTINGS.REGEX.LETTERS.EXP),
          ]),
        ],
      ],
      mobileNumber: [
        null,
        [
          Validators.compose([
            Validators.required,
            Validators.pattern(SETTINGS.REGEX.PHONE.EXP),
          ]),
        ],
      ],
      nicNo: [null, []],
      // assignsVehicles: [null, []],
      email: [null, [Validators.email]],
      canDrive: [this.canDriveOptions, []],
      languageSkills: this.fb.array([this.createLanguage()]),
      licenseDetails: this.fb.group({
        drivingLicenseExpiryDate: [null, []],
        hasTourDriverLicense: [null],
        tourDriverLicenseExpiryDate: [null],
        hasChauffeurGuideLicense: [null],
        chauffeurGuideLicenseExpiryDate: [null],
        hasNationalGuideLicense: [null],
        nationalGuideLicenseExpiryDate: [null],
        attachments: [null],
      }),
      notes: [null],
    });

    this.driverForm.valueChanges.subscribe((values: any) => {
      if (values.driverSegment) {
        switch (values.driverSegment) {
          case 'OUTSOURCE_DRIVER':
            this.isOutsourceDriver = true;
            this.isSrDriver = false;
            this.driverForm
              .get('isRegistered')
              .setValidators(Validators.required);
            this.driverForm.get('canDrive').clearValidators();
            this.driverForm.get('contractOrPermanent').clearValidators();
            this.driverForm
              .get('licenseDetails')
              .controls.drivingLicenseExpiryDate.clearValidators();
            this.driverForm.get('nicNo').clearValidators();
            this.driverForm.get('supplier').addValidators(Validators.required);
            break;

          case 'SR_DRIVER':
            this.isOutsourceDriver = false;
            this.isSrDriver = true;
            this.driverForm
              .get('contractOrPermanent')
              .addValidators(Validators.required);
            this.driverForm.get('isRegistered').clearValidators();
            this.driverForm.get('nicNo').addValidators(Validators.required);
            this.driverForm.get('canDrive').addValidators(Validators.required);
            this.driverForm
              .get('licenseDetails')
              .controls.drivingLicenseExpiryDate.addValidators(
                Validators.required,
              );
            this.driverForm.get('supplier').clearValidators();
            break;
        }
        this.driverForm.get('isRegistered').updateValueAndValidity();
      }

      this.hasTourLicense = !!values.licenseDetails.hasTourDriverLicense;
      this.hasChauffeurGuideLicense =
        !!values.licenseDetails.hasChauffeurGuideLicense;
      this.hasNationalGuideLicense =
        !!values.licenseDetails.hasNationalGuideLicense;

      this.formErrors = AppUtils.getFormErrors(
        this.driverForm,
        this.formErrors,
      );

      this.innerLicenseDetailsErrors.licenseDetails = AppUtils.getFormErrors(
        this.driverForm.get('licenseDetails'),
        this.innerLicenseDetailsErrors.licenseDetails,
      );
    });
  }

  licenceUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_LICENCE_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.licenceAttachments.push({ name: item.file.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_LICENCE_UPLOAD,
          loading: false,
        });
        this.messages.create('success', `Attachment has been uploaded!`);
      });

  otherAttachmentOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.otherAttachments.push({ name: item.file.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_OTHER_ATTACHMENTS_UPLOAD,
          loading: false,
        });
        this.messages.create('success', `Attachment has been uploaded!`);
      });

  removeAttachment(index: number, type: string): void {
    switch (type) {
      case 'licences':
        this.licenceAttachments.splice(index, 1);
        this.messages.create('success', `Attachment has been deleted!`);
        break;
      case 'other':
        this.otherAttachments.splice(index, 1);
        this.messages.create('success', `Attachment has been deleted!`);
        break;
    }
  }

  removeVehiclePhoto(): void {
    console.log('CLICKED');
  }

  cancelSave(): void {
    this.driverForm.reset();
    this.router.navigate(['/admin/drivers']);
  }

  cancel(): void {}

  vehicleImageOnUpload = (item: NzUploadXHRArgs) =>
    this.filesService
      .postFile(item.file, ADD_EDIT_DRIVER_LICENCE_UPLOAD)
      .subscribe((res) => {
        const data = res as any;
        this.licenceAttachments.push({ name: data.name, url: data.url });
        this.filesService.fileUploadingSubject.next({
          type: ADD_EDIT_DRIVER_LICENCE_UPLOAD,
          loading: false,
        });
      });

  setVehicleIndex(index: any): void {}

  submitData(): void {
    const canDrive: any[] = [];
    let payload: any = {};
    try {
      this.driverForm.patchValue({
        licenseDetails: {
          attachments: this.licenceAttachments,
        },
      });
      const formData = this.driverForm.getRawValue();
      formData.canDrive.forEach((op: any) => {
        canDrive.push({ label: op.label, checked: op.checked });
      });
      formData.canDrive = canDrive;
      // if (this.isASupplier) {
      //   formData.paymentDetails = null;
      // }
      // formData.isASupplier = this.isASupplier;
      payload = {
        ...formData,
        attachments:
          this.otherAttachments?.length > 0 ? this.otherAttachments : null,
      };
      if (this.driverId) {
        this.driverService
          .updateDriver({ _id: this.driverId, ...payload })
          .subscribe(
            (res: any) => {
              this.messages.create('success', `Driver has been updated!`);
              if (this.prevPage) {
                this.submit = true;
                this.router.navigate([`/admin/drivers/${this.driverId}`]);
              } else {
                this.submit = true;
                this.router.navigate(['/admin/drivers']);
              }
            },
            (e: any) => {
              if (e?.error?.errors?.email) {
                this.messages.create('error', `Email is already existing!`);
              }
            },
          );
      } else {
        this.driverService.createDriver(payload).subscribe(
          (res) => {
            this.messages.create('success', `New driver has been added!`);
            this.submit = true;
            this.router.navigate(['/admin/drivers']);
          },
          (e: any) => {
            if (e?.error?.errors?.email) {
              this.submit = true;
              this.messages.create('error', `Email is already existing!`);
            }
          },
        );
      }
    } catch (e: any) {}
  }

  onSubmitCancel(): void {
    this.router.navigate([`admin/drivers`]);
  }

  onGetAddSupplierChange(event: any): void {
    switch (event.name) {
      case 'isVisible':
        this.visibleAddSupplierPopup = false;
        break;
      case 'created':
        this.messages.create('success', 'New Supplier has been added!');
        this.getSuppliers();
        this.visibleAddSupplierPopup = false;
        break;
    }
  }

  canExit(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.submit) {
      return true;
    } else if (this.driverForm.dirty || this.driverForm.touched) {
      return confirm(
        ' You have unsaved changes, Do you really want to discard these changes?',
      );
    } else {
      return true;
    }
  }
}
